import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Column from '../../../layout/Column'
import Columns from '../../../layout/Columns'
import Button from '../../../elements/Button'
import Highlight from '../../../custom/Highlight'
import Staff from '../../../custom/Staff'
import IconBack from '/public/icons/icon-previous.svg'
import IconMore from '/public/icons/icon-more.svg'
import styles from './styles.module.scss'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { withModifiers } from '../../../helpers/withModifiers'
import { useResponsive } from '../../../../providers/ResponsiveContext'

const Introduction = ({
  location,
  title,
  description,
  contact,
  button = true,
  translations
}) => {
  const router = useRouter()
  const isRealEstate = router.pathname.includes('real-estate')
  const [show, setShow] = useState(false)
  const { isDesktop, isSmallMobile } = useResponsive()

  const [loaded, setLoaded] = useState(false)
  useEffect(() => setLoaded(true), [])

  if (loaded) {
    return (
      <Section variant={['white', 'p-xl']}>
        <Container>
          <Columns
            variant={[isSmallMobile ? '-align-center' : '-distribute-between']}
          >
            <Column spans={isSmallMobile ? 12 : 6}>
              <div className={styles.intro}>
                <Button
                  arrow={false}
                  className={styles.intro__button}
                  prepend={<IconBack width={23} />}
                  variant={['label', 'blue']}
                  onClick={() => router.back()}
                >
                  {translations?.back[router.locale]}
                </Button>
                <span className={styles.intro__divider}>/</span> {location}
              </div>
              {title && <h2 className={styles.intro__title}>{title}</h2>}

              {description && (
                <>
                  <div
                    className={withModifiers(
                      'intro__description',
                      [show && 'is-visible'],
                      styles
                    )}
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></div>

                  <Button
                    className={styles.intro__more}
                    arrow={false}
                    appendIcon={
                      <IconMore
                        className={withModifiers(
                          'intro__icon',
                          [show && 'up'],
                          styles
                        )}
                      />
                    }
                    variant={['label', 'blue']}
                    onClick={() => setShow(!show)}
                  >
                    {show
                      ? translations?.readLess[router.locale]
                      : translations?.readMore[router.locale]}
                  </Button>
                </>
              )}
            </Column>

            <Column spans={isSmallMobile ? 8 : 5}>
              {contact && (
                <div className={styles.intro__column}>
                  <Staff
                    variant={[
                      !isDesktop && 'align-middle',
                      isDesktop && 'columns',
                      'remove-job',
                      isRealEstate && 'color-accent'
                    ]}
                    {...contact}
                    button={
                      button && {
                        label: isRealEstate ? (
                          <>
                            <Highlight
                              variant={[
                                'accent',
                                'arrow-accent',
                                'offset-left'
                              ]}
                            >
                              {translations?.buying[router.locale]}
                            </Highlight>
                            {translations?.options[router.locale]}
                          </>
                        ) : (
                          <>
                            {translations?.askAbout[router.locale]}
                            <Highlight>
                              {translations?.renting[router.locale]}
                            </Highlight>
                          </>
                        ),
                        variant: 'arrow-accent'
                      }
                    }
                  />
                </div>
              )}
            </Column>
          </Columns>
        </Container>
      </Section>
    )
  }
  return
}

export default Introduction
